import { render } from "./TosPage.vue?vue&type=template&id=2d3bcc74&scoped=true&ts=true"
import script from "./TosPage.vue?vue&type=script&lang=ts"
export * from "./TosPage.vue?vue&type=script&lang=ts"

import "./TosPage.vue?vue&type=style&index=0&id=2d3bcc74&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3bcc74"]])

export default __exports__